import { render } from "./scan.vue?vue&type=template&id=18bfeda1"
import script from "./scan.vue?vue&type=script&lang=js"
export * from "./scan.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/work/mywork/selecthouse/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__